/**
 * Helper type for creating generic signatures for unknown types
 * that you want to spread, like
 * <T extends Spreadable>(obj: T): T & {injected: boolean} => {...obj, injected: true};
 *
 * It is not possible to use just <T> or <T extends unknown> because spread cannot
 * be performed on such type, and not advised to use Record<string, any>
 * because everything passed to that argument would have to have type with index signature.
 *
 * By using this type we make it nicely semantically readable and
 * don't have to disable ban-types lint everywhere.
 */
export type Spreadable =
  // biome-ignore lint/complexity/noBannedTypes: semantically aliased on purpose, see comment above
  {};
